import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import PaginationNew from '@components/pagination-new'
import Button from '@material-ui/core/Button'
import CardProgram from '@components/card-program/index'
import useStyles from './program-grid.styles'
import usePagination from './usePagination'

const ProgramGrid = (props) => {
  const {
    total,
    headline,
    items,
  } = props
  const styles = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const limit = isMobile ? 4 : 8
  const showTags = total > 1
  const [selectedCategory, setSelectedCategory] = useState('')
  const [showProgramCollection, setShowProgramCollection] = useState(false)

  const [
    data, loading, handlePagination, handleCategoryChange, skip,
  ] = usePagination(isMobile, limit, items)

  useEffect(() => {
    if (selectedCategory) {
      handleCategoryChange(selectedCategory)
    }
    if (!showProgramCollection) {
      setShowProgramCollection(total > 0 && data?.promotionalPageCollection?.total > 0)
    }
  }, [selectedCategory, data])

  const handleTagClick = (itemId) => {
    if (itemId === selectedCategory) {
      setSelectedCategory('')
      handleCategoryChange('')
    } else {
      setSelectedCategory(itemId)
    }
  }

  const handleAllProgramsClick = () => {
    setSelectedCategory('')
    handleCategoryChange('')
  }

  return showProgramCollection && (
    <Box className={styles.root}>
      <Container>
        <Box pt={4} pb={7}>
          <Typography
            variant="h4"
            variantMapping={{ h4: 'h2' }}
            className={styles.headline}
          >{headline}
          </Typography>

          {(showProgramCollection && showTags) && (
            <>
            <Box mb={3} className={styles.categoryTagsRow} role="group" aria-label={`${headline} single select filter buttons`}>
              <Button
                onClick={handleAllProgramsClick}
                className={`${styles.categoryTags} ${selectedCategory === '' ? styles.active : ''}`}
                aria-label={selectedCategory === '' ? 'All programs filter activated. Select another tag to apply filters' : 'All programs'}
              >
                All Programs
              </Button>
              {items.map(item => (
                <Button
                  onClick={() => handleTagClick(item.sys.id)}
                  key={item.sys.id}
                  className={`${styles.categoryTags} ${item.sys.id === selectedCategory ? styles.active : ''}`}
                  aria-label={item.sys.id === selectedCategory ? `${item.name} filter activated. Re-select to remove filter` : item.name}
                >{item.name}
                </Button>
              ))}
            </Box>
            <Box className={styles.divider} />
            </>
          )}
          <Box mb={5}>
            {loading && <LinearProgress color="secondary" />}
          </Box>

          {data?.promotionalPageCollection.items.length > 0 && (
            <Box className={styles.eventsWrapper}>
              {data.promotionalPageCollection.items.map(item => (
                <CardProgram showProgramCollection={showProgramCollection} showTags={showTags} key={item.sys.id} {...item} />
              ))}
            </Box>
          )}
          {isMobile ? (
          data?.promotionalPageCollection?.items.length !== data?.promotionalPageCollection.total && (
              <Box className={styles.mobileLoadMore} my={5}>
                <Button disabled={loading} onClick={() => handlePagination()} aria-label="Load More Events" variant="contained" color="primary">Load More</Button>
              </Box>
            )
          ) : (
        data?.promotionalPageCollection && data?.promotionalPageCollection.total > limit && (
              <PaginationNew
                limit={limit}
                offset={skip}
                total={data.promotionalPageCollection.total}
                onClick={(e, newOffset) => handlePagination(newOffset)}
              />
            )
          )}
        </Box>
      </Container>
    </Box>
  )
}

ProgramGrid.propTypes = {
  total: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
      sys: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  ),
  headline: PropTypes.string,
}

export default ProgramGrid
